module.exports = __webpack_public_path__ + "static/img/per7.5764f5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per7.jpg
// module id = ZLZT
// module chunks = 41